import React, { useState, useEffect } from "react";
import moment from "moment";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
	DownloadOutlined,
	EyeOutlined,
	DeleteOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import HttpService from "../services/httpService";
import TextField from "@material-ui/core/TextField";
import { useSelector } from "react-redux";
import {
	Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	DialogContentText,
} from "@material-ui/core";
import { ROLENAME } from "../utils/index";
import { Checkbox, FormControlLabel } from "@mui/material";
const useStyles = makeStyles((theme) => ({
	table: {
		minWidth: 700,
	},
	formControl: {
		margin: theme.spacing(3),
	},
	root: {
		display: "flex",
	},
	textField: {
		width: "100px",
	},
}));

const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: "#3F51B5",
		color: "#FFF",
		fontWeight: "1000",
	},
	body: {
		fontSize: 14,
	},
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
	root: {
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);

const PoStdRateDetailsModal = (props) => {
	const classes = useStyles();
	const [poDetails, setPoDetails] = useState([]);
	const { userDetails } = useSelector((state) => state.user);
	const [rejectOpenModel, setRejectOpenModel] = useState(false);
	const [remarks, setRemarks] = useState("");
	const [rejectionInfo, setRejectionInfo] = useState({
		procurementId: "",
		index: "",
	});

	// Function to handle checkbox checking for "approveCurrentPoCheck"
	const approveCurrentPoCheckHandler = (event, index) => {
		let arr = { ...poDetails };
		arr.materials[index].approveForCurrentPo =
			arr.materials[index].approveForCurrentPo;
		setPoDetails(arr);
	};

	// Function to handle checkbox checking for "updateStdRateCheck"
	const updateStdRateCheckHandler = (event, index) => {
		let arr = { ...poDetails };
		arr.materials[index].updateStandardRateOfMaterial =
			!arr.materials[index].updateStandardRateOfMaterial;
		setPoDetails(arr);
	};

	useEffect(() => {
		setPoDetails(props?.PODETAILS);
	}, [props?.PODETAILS]);

	// Function to approve procurement or send it for std price updation approval
	const approveProcurement = async (procurementId, index) => {
		props.setLoading(true);
		try {
			const obj = [];
			let data = {
				materialElementId: poDetails?.materials[index]?._id,
				materialId: poDetails?.materials[index]?.materialId?._id,
				pricePerUnit: poDetails?.materials[index]?.pricePerUnit,
				requestedPrice: poDetails?.materials[index]?.approvedRate,
				requestedQuantity: poDetails?.materials[index]?.approvedQuantity,
				projectId: props?.SELECTEDPROJECT?._id ?? poDetails?.projectId?._id,
				projectMaterialId: poDetails?.materials[index]?.projectMaterialId,
				quantity: poDetails?.materials[index]?.quantity,
				scopeId: poDetails?.materials[index]?.scopeId?._id,
				approveForCurrentPo: poDetails?.materials[index]?.approveForCurrentPo,
				updateStandardRateOfMaterial:
					poDetails?.materials[index]?.updateStandardRateOfMaterial,
				vendorId: poDetails?.vendorId?._id,
			};
			obj.push(data);
			if (
				poDetails?.materials[index].approveForCurrentPo &&
				poDetails?.materials[index].updateStandardRateOfMaterial &&
				poDetails?.materials[index].operationHeadApproved
			) {
				const result = await HttpService.approveProcurementUpdateStdRate(
					procurementId,
					obj
				);
				if (result.status === 200) {
					props.setSnackInfo("PO Approved & Std Rate Updated", "success");
					props.REFRESH(procurementId);
				}
			}
			if (
				poDetails?.materials[index].approveForCurrentPo &&
				!poDetails?.materials[index].updateStandardRateOfMaterial
			) {
				const result = await HttpService.approveProcurement(procurementId, obj);
				if (result.status === 200) {
					props.setSnackInfo("PO Approved", "success");
					props.REFRESH(procurementId);
				}
			}
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data, "error");
		}
		props.setLoading(false);
	};

	// Function to reject the procurement
	const rejectProcurementConfirm = async (procurementId, index) => {
		props.setLoading(true);
		try {
			if (remarks === "") {
				props.setSnackInfo("Please Enter your remark", "error");
			} else {
				const obj = [];
				let data = {
					materialElementId: poDetails?.materials[rejectionInfo?.index]?._id,
					materialId:
						poDetails?.materials[rejectionInfo?.index]?.materialId?._id,
					pricePerUnit:
						poDetails?.materials[rejectionInfo?.index]?.pricePerUnit,
					requestedPrice:
						poDetails?.materials[rejectionInfo?.index]?.requestedPrice,
					requestedQuantity:
						poDetails?.materials[rejectionInfo?.index]?.requestedQuantity,
					projectId: props?.SELECTEDPROJECT?._id ?? poDetails?.projectId?._id,
					projectMaterialId:
						poDetails?.materials[rejectionInfo?.index]?.projectMaterialId,
					quantity: poDetails?.materials[rejectionInfo?.index]?.quantity,
					scopeId: poDetails?.materials[rejectionInfo?.index]?.scopeId?._id,
					remarks: remarks,
				};
				obj.push(data);
				const result = await HttpService.rejectProcurement(
					rejectionInfo?.procurementId,
					obj
				);
				if (result.status === 200) {
					props.setSnackInfo("PO Rejected", "success");
					props.REFRESH(rejectionInfo?.procurementId);
				}
				setRejectOpenModel(false);
				// setRejectionInfo({procurementId:"",index:""});
				// setRemarks("");
                setRejectionInfo({ procurementId: "", index: "" });
				setRemarks("");
			}
		} catch (error) {
			console.error(error);
			props.setSnackInfo(error?.response?.data, "error");
		}
		props.setLoading(false);
	};

	// Function to handle the change in requested qty
	const handleRequestQunatityChange = (e, i) => {
		let po = { ...poDetails };
		po.materials[i].requestedQuantity = e.target.value;
		setPoDetails(po);
	};

	// Function to handle the change in requested price
	const handelRequestPriceChange = (e, i) => {
		let po = { ...poDetails };
		po.materials[i].requestedPrice = e.target.value;
		setPoDetails(po);
	};

	// Function to download maksed PO
	const getMaskedPODocument = async (data) => {
		try {
			const result = await HttpService.generateMaskedPo(data._id);
			window.open(result.data.link);
		} catch (error) {
			console.error(error, "error");
		}
	};

	const rejectPO = (procurementId, index) => {
		setRejectOpenModel(true);
		setRejectionInfo({ procurementId: procurementId, index: index });
	};

	return (
		<div>
			<div className="modal-header" style={{ justifyContent: "space-between" }}>
				<div style={{ width: "25%" }}>
					<b>OrderID: </b>
					<span>{poDetails.orderId}</span>
				</div>
				<div style={{ width: "25%" }}>
					<b>Created At: </b>
					<span>{moment(poDetails.createdAt).format("DD-MM-YYYY")}</span>
				</div>
				<div style={{ width: "25%" }}>
					<b>Project Code: </b>
					<span>{poDetails.projectId?.code ?? "OPEN"}</span>
				</div>
			</div>
			<div className="modal-header" style={{ justifyContent: "space-between" }}>
				<div style={{ width: "25%" }}>
					<b>Client: </b>
					<span>{poDetails.projectId?.clientName ?? "PROCUREMENT"}</span>
				</div>
				<div style={{ width: "25%" }}>
					<span
						className="btn"
						onClick={() =>
							props.VIEWALL(
								props.TITLE !== "Approve Std Rate"
									? "PO/MTR Raised/Requested"
									: "TEST"
							)
						}
					>
						View All <EyeOutlined />
					</span>
					<br />
					<br />
				</div>
			</div>
			<TableContainer component={Paper}>
				<Table
					className={classes.table}
					size="small"
					aria-label="customized table"
				>
					<TableHead>
						<TableRow>
							<StyledTableCell>Sl No</StyledTableCell>
							<StyledTableCell>Material Code</StyledTableCell>
							<StyledTableCell>Scope</StyledTableCell>
							<StyledTableCell>Status</StyledTableCell>
							<StyledTableCell>Vendor Rate</StyledTableCell>
							<StyledTableCell>Requested Rate</StyledTableCell>
							<StyledTableCell>Approved Rate (Ops-Head)</StyledTableCell>
							<StyledTableCell>Unit</StyledTableCell>
							<StyledTableCell>BOM Qty</StyledTableCell>
							<StyledTableCell>Requested Qty</StyledTableCell>
							<StyledTableCell>Approved Qty (Ops-Head)</StyledTableCell>
							<StyledTableCell>Standard Total Value</StyledTableCell>
							<StyledTableCell>Requested Value</StyledTableCell>
							<StyledTableCell>Approved Value</StyledTableCell>
							{props.TITLE === "Approve Std Rate" &&
								poDetails?.status !== "Approved" &&
								poDetails?.status !== "Rejected" && (
									<>
										{/* <StyledTableCell align="center">
											Approve For Current PO
										</StyledTableCell> */}
										<StyledTableCell align="center">
											Update Std Rate Card
										</StyledTableCell>
										<StyledTableCell align="center">Action</StyledTableCell>
									</>
								)}
						</TableRow>
					</TableHead>
					<TableBody>
						{poDetails?.materials?.map((data, i) => (
							<StyledTableRow StyledTableRow key={i + 1}>
								<StyledTableCell>{i + 1}</StyledTableCell>
								<StyledTableCell>{data?.materialId?.code}</StyledTableCell>
								<StyledTableCell>{data?.scopeId?.name}</StyledTableCell>
								<StyledTableCell>{data?.status}</StyledTableCell>
								<StyledTableCell>
									{parseFloat(data?.pricePerUnit).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>
									{parseFloat(data?.originallyRequestedRate).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>
									{parseFloat(data?.approvedRate).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>{data?.unitId?.name}</StyledTableCell>
								<StyledTableCell>
									{parseFloat(data?.quantity).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>
									{parseFloat(data?.originallyRequestedQty).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>
									{parseFloat(data?.approvedQuantity).toFixed(2)}
								</StyledTableCell>
								{/* <StyledTableCell>
									{data?.requestedQuantity * data?.requestedPrice}
								</StyledTableCell> */}
                                <StyledTableCell>
									{parseFloat(
										data?.pricePerUnit * data?.originallyRequestedQty
									).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>
									{parseFloat(
										data?.originallyRequestedRate * data?.originallyRequestedQty
									).toFixed(2)}
								</StyledTableCell>
								<StyledTableCell>
									{parseFloat(
										data?.approvedRate * data?.approvedQuantity
									).toFixed(2)}
								</StyledTableCell>
								{/* {props.TITLE === "Approve Std Rate" &&
									data?.status !== "Approved" &&
									data?.status !== "Rejected" &&
									poDetails?.status !== "Approved" &&
									poDetails?.status !== "Rejected" && (
										<StyledTableCell>
											{data?.requestedPrice != data?.pricePerUnit && (
												<FormControlLabel
													onChange={(e) => approveCurrentPoCheckHandler(e, i)}
													control={
														<Checkbox checked={data?.approveForCurrentPo} />
													}
													label=""
												/>
											)}
										</StyledTableCell>
									)} */}
								{props.TITLE === "Approve Std Rate" &&
									data?.status !== "Approved" &&
									data?.status !== "Rejected" &&
									poDetails?.status !== "Approved" &&
									poDetails?.status !== "Rejected" && (
										<StyledTableCell>
											{data?.requestedPrice != data?.pricePerUnit && (
												<FormControlLabel
													onChange={(e) => updateStdRateCheckHandler(e, i)}
													control={
														<Checkbox
															checked={data?.updateStandardRateOfMaterial}
														/>
													}
													label=""
												/>
											)}
										</StyledTableCell>
									)}
								{props.TITLE === "Approve Std Rate" &&
									data?.operationHeadApproved === true &&
									data?.status !== "Approved" &&
									data?.status !== "Rejected" &&
									poDetails?.status !== "Approved" &&
									poDetails?.status !== "Rejected" && (
										<StyledTableCell>
											{" "}
											<div className="approve-reject-btn">
												<button
													onClick={() => approveProcurement(poDetails?._id, i)}
													className="approve-btn"
												>
													Approve
												</button>
												<button
													onClick={() => rejectPO(poDetails?._id, i)}
													className="reject-btn"
												>
													Reject
												</button>
											</div>
										</StyledTableCell>
									)}
							</StyledTableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
			<div>
				<Dialog
					open={rejectOpenModel}
					onClose={() => setRejectOpenModel(false)}
					aria-labelledby="form-dialog-title"
					maxWidth="sm"
					fullWidth
				>
					<DialogContent>
						<DialogContentText>Enter Remarks For Rejection</DialogContentText>
						<TextField
							id="remarks"
							name="Remarks"
							label="Add Remarks"
							variant="outlined"
							type="text"
							value={remarks}
							onChange={(e) => setRemarks(e.target.value)}
							fullWidth
						/>
					</DialogContent>
					<DialogActions>
						<Button
							variant="outlined"
							onClick={() => setRejectOpenModel(false)}
							color="secondary"
						>
							Cancel
						</Button>
						<Button
							onClick={rejectProcurementConfirm}
							variant="outlined"
							color="primary"
						>
							Submit
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		</div>
	);
};

export default connect(null, { setLoading, setSnackInfo })(
	PoStdRateDetailsModal
);